import { createActions } from '../../createActions';

export const onchainHoldersActions = createActions({});
